import React, { useState, useEffect } from 'react';
import { validateEntraEmail } from '../utils/emailValidator';

const AddAdminModal = ({ onClose, onAddAdmin, loading, prefillDisplayName }) => {
const [newAdminEmail, setNewAdminEmail] = useState('');
const [newAdminName, setNewAdminName] = useState('');
const [validationError, setValidationError] = useState('');

// Update display name if prefilled value is provided
useEffect(() => {
  if (prefillDisplayName) {
    setNewAdminName(prefillDisplayName);
  }
}, [prefillDisplayName]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setValidationError('');
    
  if (!newAdminEmail.trim()) {
    setValidationError('Email is required');
    return;
  }

  // Validate that the email is suitable for Entra ID (not a consumer email)
  const emailValidation = validateEntraEmail(newAdminEmail);
  if (!emailValidation.isValid) {
    setValidationError(emailValidation.error);
    return;
  }

  if (!newAdminName.trim()) {
    setValidationError('Display Name is required');
    return;
  }

    try {
      await onAddAdmin(
        newAdminEmail.trim(), 
        newAdminName.trim()
      );
      // If successful, the parent will handle closing the modal
      setNewAdminEmail('');
      setNewAdminName('');
      onClose();
    } catch (err) {
      // Error is handled by parent component
      console.error('Add admin error:', err);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '550px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, color: '#333', fontSize: '1.5rem' }}>Add New Administrator</h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="adminEmail" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
              Email Address *
            </label>
            <input
              id="adminEmail"
              type="email"
              value={newAdminEmail}
              onChange={(e) => setNewAdminEmail(e.target.value)}
              placeholder="admin@example.com"
              required
              disabled={loading}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '1rem'
              }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: '1.5rem' }}>
            <label htmlFor="adminName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
              Display Name *
            </label>
            <input
              id="adminName"
              type="text"
              value={newAdminName}
              onChange={(e) => setNewAdminName(e.target.value)}
              placeholder="John Doe"
              required
              disabled={loading}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '1rem'
              }}
            />
          </div>

          {/* Validation Error */}
          {validationError && (
            <div style={{
              marginBottom: '1rem',
              padding: '1rem',
              background: '#fee2e2',
              border: '1px solid #fca5a5',
              borderRadius: '6px'
            }}>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#991b1b', fontWeight: '600' }}>
                {validationError}
              </p>
            </div>
          )}

          {/* Info Box */}
          <div style={{ 
            marginBottom: '1.5rem', 
            padding: '1rem', 
            background: '#fff3cd', 
            border: '1px solid #ffc107',
            borderRadius: '6px'
          }}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#856404', fontWeight: 'bold' }}>
              Entra ID Work/School Accounts Only
            </p>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#856404' }}>
              Administrators must use Microsoft work or school accounts (Azure AD/Entra ID).
            </p>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Administrator'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdminModal;
